import {useState} from 'react';

import Checkbox from "@material-tailwind/react/Checkbox";
import Card from '@material-tailwind/react/Card';
import CardBody from '@material-tailwind/react/CardBody';
import CardFooter from '@material-tailwind/react/CardFooter';
import Input from '@material-tailwind/react/Input';
import Button from '@material-tailwind/react/Button';
import Icon from '@material-tailwind/react/Icon';
import { Paragraph } from '@material-tailwind/react';

export default function BitcoinAddress({stage, setStage}) {
    const [addressName, setAddressName] = useState('');
    const [btcAddress, setBtcAddress] = useState('');
    const [error, setError] = useState({});
    const [acknowledge,setAcknowledge] = useState(false);
    
    function clearError(key) {
        if (key && typeof key === 'string') {
            const tempErrors = error;

            tempErrors[key] = null;

            setError(tempErrors);
        }
    }

    function onDoneClick() {
        let tempErrors = {};
        if (!addressName) {
            tempErrors.addressName = 'Please enter your address name';
        }
        if (!btcAddress) {
            tempErrors.btcAddress = 'Please enter your Bitcoin address';
        }
        if (!acknowledge) {
            tempErrors.acknowledge = 'Please acknowledge the conditions';
        }
        if (tempErrors && typeof tempErrors === 'object' && Object.keys(tempErrors).length > 0) {
            setError(tempErrors);

            return;
        }
        
        setStage(stage + 1);
    }

    return (
        <div className="h-screen px-3 md:px-8 flex relative justify-center">
            <div className="mt-12">
                <h3 className="font-light text-4xl text-white">Bitcoin address</h3>
                <div className="h-2" />
                <Paragraph color="white">
                Enter your bitcoin address below
                </Paragraph>
                <div className="h-10" />
                <Card className="max-w-3xl text-left bg-primary">  
                    <div className="h-2" />
                    <CardBody>
                        <div className="mb-4 text-left">
                            <Input
                                outline={false}
                                value={addressName}
                                onChange={e => setAddressName(e.target.value)}
                                type="text"
                                color="green"
                                placeholder="Address name"
                                size="regular"
                                error={error && error.addressName}
                                onFocus={() => clearError('addressName')}
                            />
                        </div>

                        <div className="mb-4 text-left">
                            <Input
                                outline={false}
                                value={btcAddress}
                                onChange={e => setBtcAddress(e.target.value)}
                                type="text"
                                color="green"
                                placeholder="Bitcoin address"
                                size="regular"
                                error={error && error.btcAddress}
                                onFocus={() => clearError('btcAddress')}
                            />
                        </div>

                    </CardBody>
                    <CardFooter>
                        <Button
                            color="green"
                            className="hover:bg-green hover:text-white w-full hover:shadow-xl hover:pr-2"
                            buttonType="outline"
                            size="lg"
                            ripple="dark"
                            onClick={onDoneClick}
                        >
                            Done
                            <Icon name="arrow_forward" size="sm" />
                        </Button>
                        <div className="h-5" />

                        <Paragraph color="white">
                            By withdrawing, I acknowledge that Venturebay is not responsible for any coins sent to the wrong address.
                        </Paragraph>
                        <Paragraph color="white">
                            I am the sole owner and operator of this Bitcoin address. Bitcoin sent to 3rd party addresses won't be processed.
                        </Paragraph>
                        <Paragraph color="white">
                            I understand that I will not be able to withdraw from my account to this Bitcoin address for 24 hours after updating it.
                        </Paragraph>
                        <Checkbox
                            color="white"
                            text="I acknowledge"
                            id={`checkbox-btc`}
                            className="flex-shrink-0"
                            onClick={() => setAcknowledge(!acknowledge)}
                        />
                        {error && error.acknowledge && <p className="text-red text-left my-4">{error.acknowledge}</p>}
                    </CardFooter>
                </Card>
                <div className="h-10" />
            </div>
        </div>
    );
}
